import { cn } from "@utils/tw"
import { motion } from "motion/react"
import { ReactNode, useEffect, useState } from "react"

export const Expandable = ({
  anchor,
  startOpen = env.admin,
  label,
  icon,
  iconOpen,
  children,
  className,
  buttonClassName,
  contentClassName,
}: {
  anchor?: string
  startOpen?: boolean
  label: ReactNode
  icon?: ReactNode
  iconOpen?: ReactNode
  children: ReactNode
  className?: string
  buttonClassName?: string
  contentClassName?: string
}) => {
  const [open, setOpen] = useState(startOpen)
  const Icon = open ? iconOpen || icon : icon

  useEffect(() => {
    setOpen(startOpen)
  }, [startOpen])

  return (
    <div className={cn("w-full flex flex-col justify-between items-center group relative", className)}>
      <a id={anchor} className="block w-full">
        <button
          className={cn(
            "w-full flex items-center justify-between type-label text-left gap-4 cursor-pointer",
            buttonClassName,
          )}
          onClick={() => setOpen(env.admin || !open)}
        >
          <div className="w-full flex justify-start items-center">{label}</div>
          <div
            className={cn(
              "flex items-center justify-center",
              // "transition-transform duration-300",
              // open && "rotate-180",
            )}
          >
            {Icon}
            {!icon && icon !== false && (
              <svg
                viewBox="0 0 11 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-[0.6em] h-[0.6em] inline-block transition-transform duration-300"
              >
                <path d="M5.62095 9L0.631429 0.370476H10.5981L5.62095 9Z" fill="currentColor" />
              </svg>
            )}
          </div>
        </button>
      </a>
      <motion.div
        className={cn("w-full", !open && "overflow-hidden")}
        animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
      >
        <div className={cn("pt-4 pb-0", contentClassName)}>{children}</div>
      </motion.div>
    </div>
  )
}
